<template>
  <div
    :class="['item-display', `direction-${props.direction}`, `variant-${props.variant}`]"
    :style="{
      height: props.height ? `${props.height}px` : undefined,
      maxWidth: props.maxWidth ? `${props.maxWidth}px` : undefined,
      width: props.width ? `${props.width}px` : undefined
    }"
  >
    <el-tooltip :hide-after="0" placement="top" :disabled="!tooltip">
      <template #content>
        {{ $t(item.name) }}
      </template>

      <div
        class="item-display-icon"
        :style="{
          width: `${props.size}px`,
          height: `${props.size}px, min-width: ${props.size}px, min-height: ${props.size}px`,
          display: 'flex',
          justifyContent: 'center'
        }"
      >
        <img :src="halloweenItemRegistry.resolveIcon(item)" alt="Item Icon" />
      </div>
    </el-tooltip>
    <div class="item-display-texts">
      <div v-if="showName" class="item-display-name">
        {{ $t(item.name) }}
      </div>
      <div v-if="count !== undefined" :class="['item-display-count', `count-size-${props.countSize}`]">
        {{ count }}
      </div>
    </div>
    <div v-if="$slots.attachment" class="item-display-attachment">
      <slot name="attachment" />
    </div>
  </div>
</template>
<script setup lang="ts">
import type { ItemDescription } from '~/types/halloween/items';
import halloweenItemRegistry from '~/utils/halloween/halloween-item-registry';

const props = defineProps<{
  size: number;
  count?: number | string;
  variant: 'default' | 'error';
  item: ItemDescription;
  showName?: boolean;
  direction: 'horizontal' | 'vertical';
  countSize?: 'default' | 'large';
  tooltip?: boolean;
  height?: number;
  maxWidth?: number;
  width?: number;
}>();
</script>
<style scoped>
.item-display {
  position: relative;
  display: flex;
  gap: 6px;
  justify-content: center;
  align-items: center;
  max-width: 140px;

  &.direction-horizontal {
    flex-direction: row;
  }
  &.direction-vertical {
    flex-direction: column;
    justify-content: space-between;
    height: 200px;
  }
}

.item-display-texts {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
}

.item-display-name {
  font-family: Grenze, serif;
  font-weight: 900;
  font-size: 18px;
  line-height: 17px;
  text-align: center;
}

.item-display-count {
  font-family: Eczar, serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  vertical-align: middle;
  color: #49ddaa;

  &.count-size-large {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
  }
}

.item-display.variant-error {
  .item-display-count {
    color: #f6164c;
  }
}
</style>
